// @ts-nocheck
import CircularProgress from '@mui/material/CircularProgress';
import { Box } from '@mui/material';
import { blue } from '@mui/material/colors';
import { useTranslation } from 'react-i18next';
import { XGButton } from 'xg-cl';
import * as PropTypes from 'prop-types';
import './UpdateActions.css';

/**
 * Render update actions for the modal footer component.
 *
 * @param {function} onCancel - Callback function for cancel action
 * @param {function} onSubmit - Callback function for submit action
 * @param {boolean} isSubmitting - Flag indicating if form is currently submitting
 * @return {JSX.Element} The update actions component
 */
const UpdateActions = ({ onCancel, onSubmit, isSubmitting }) => {
  const { t } = useTranslation(['common']);

  return (
    <Box
      className='update-action-modal__footer'
      data-testid='update-modal-actions'
    >
      <Box sx={{ position: 'relative', width: '50%' }}>
        <XGButton
          style={{
            width: '100%'
          }}
          data-testid='update-action-cancel-button'
          id='update-action-cancel-button'
          text={t('confirmUpdation')}
          type='primary'
          size='large'
          variant='outlined'
          onClick={onSubmit}
          disabled={isSubmitting}
        />
        {isSubmitting && (
          <CircularProgress
            id='update-actions-loader'
            size={24}
            sx={{
              color: blue[500],
              position: 'absolute',
              top: '50%',
              left: '50%',
              marginTop: '-12px',
              marginLeft: '-12px'
            }}
          />
        )}
      </Box>
      <XGButton
        data-testid='update-action-confirm-button'
        id='update-action-confirm-button'
        text={t('cancelUpdation')}
        type='primary'
        size='large'
        variant='contained'
        onClick={onCancel}
      />
    </Box>
  );
};

UpdateActions.propTypes = {
  onCancel: PropTypes.func,
  onSubmit: PropTypes.func,
  isSubmitting: PropTypes.bool
};

export default UpdateActions;
